// «قصه‌های تعاملی» — the tale books. Keys mirror backend services/tales.py CATALOG.
// The book itself (pages, scenes) is only loaded when it is opened (Library.jsx is
// lazy); the card on Home needs just this small cover description.
export const TALES = {
  lantern: {
    base: "/tales/lantern/",
    v: 6,           // keep equal to the tale file's `v` — cache-buster
    // the card's live preview: a painted back card + a figure that breathes in front
    cover: { bg: "room.webp", bgPos: "50% 62%", hero: "arman-stand.webp", side: "bunny.webp", glow: true },
    coverFile: "cover.webp", heroFile: "arman-stand.webp",   // warmed on Home for the shelf
    pages: 7,
    minutes: 2,
  },
  chai: {
    base: "/tales/chai/",
    v: 2,           // keep equal to the tale file's `v` — cache-buster
    cover: { bg: "court.webp", bgPos: "50% 70%", hero: "nila-happy.webp", side: "tower-tall.webp", glow: false },
    coverFile: "cover.webp", heroFile: "nila-happy.webp",
    pages: 7,
    minutes: 2,
  },
  nakh: {
    base: "/tales/nakh/", v: 4,
    cover: { bg: "gate.webp", bgPos: "50% 70%", hero: "hero.webp", side: "sparrow-clay.webp", glow: false },
    coverFile: "cover.webp", heroFile: "hero.webp", pages: 7, minutes: 2,
  },
  sabzeh: {
    base: "/tales/sabzeh/", v: 4,
    cover: { bg: "room.webp", bgPos: "50% 70%", hero: "hero.webp", side: "plate-sprouts.webp", glow: false },
    coverFile: "cover.webp", heroFile: "hero.webp", pages: 7, minutes: 2,
  },
  lili: {
    base: "/tales/lili/", v: 2,
    cover: { bg: "park.webp", bgPos: "50% 70%", hero: "hero.webp", side: "ball.webp", glow: false },
    coverFile: "cover.webp", heroFile: "hero.webp", pages: 7, minutes: 2,
  },
  kite: {
    base: "/tales/kite/", v: 2,
    cover: { bg: "hill.webp", bgPos: "50% 60%", hero: "hero.webp", side: "swallow-a.webp", glow: false },
    coverFile: "cover.webp", heroFile: "hero.webp", pages: 7, minutes: 2,
  },
  baran: {
    base: "/tales/baran/", v: 4,
    cover: { bg: "yard.webp", bgPos: "50% 60%", hero: "hero.webp", side: "sparrow.webp", glow: false },
    coverFile: "cover.webp", heroFile: "hero.webp", pages: 7, minutes: 2,
  },
};
